export default "__VITE_ASSET__1xAtwJqp__"